import _ from 'lodash';

/**
 * Batch pricing is only meaningful with its unit: "per 15" says nothing, "per
 * 15 Minuten" does. Four billing views render this badge (current period,
 * history, tenant billing, features grid) and each had its own version, so they
 * drifted — three of them dropped the unit entirely. One implementation, used
 * by all of them.
 *
 * `translate` is the component's $t, `pluralize` its $tc: units are pluralized
 * on the count ("1 Minute" / "15 Minuten"), and an untranslated unit falls back
 * to the raw label instead of printing the translation key.
 */
export const batchUnit = (unitLabel, count, translate, pluralize) => {
    if (!unitLabel) {
        return translate('units');
    }

    const key = 'unit.' + unitLabel;
    const translated = pluralize(key, count);

    return translated !== key ? translated : unitLabel;
};

export const batchLabel = (row, translate, pluralize) => {
    const batchSize = parseInt(_.get(row, 'billingFeatureCost.batch_size', _.get(row, 'batch_size', 1)), 10) || 1;
    const unitLabel = _.get(row, 'billingFeatureCost.unit_label', _.get(row, 'unit_label', null));

    return [translate('per'), batchSize.toLocaleString('de-DE'), batchUnit(unitLabel, batchSize, translate, pluralize)]
        .filter(Boolean)
        .join(' ');
};
